module.exports = __webpack_public_path__ + "img/img57.665e4ea7.svg";